var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CheckmarkFill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12.25C20 16.5302 16.5302 20 12.25 20C7.96979 20 4.5 16.5302 4.5 12.25C4.5 7.96979 7.96979 4.5 12.25 4.5C16.5302 4.5 20 7.96979 20 12.25ZM16.1952 9.65617C16.4108 9.82867 16.4458 10.1433 16.2733 10.359L12.0622 15.6228L8.82321 12.3839C8.62794 12.1886 8.62794 11.872 8.8232 11.6768L9.17676 11.3232C9.37202 11.128 9.6886 11.128 9.88387 11.3232L11.9378 13.3771L15.102 9.42191C15.2745 9.20628 15.5891 9.17132 15.8048 9.34382L16.1952 9.65617Z",
    fill: "#00884F"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkmark.f668908defa72eb50d33d8c44c005502.svg";